import { render, staticRenderFns } from "./AboutCladify.vue?vue&type=template&id=68114e66&scoped=true"
var script = {}
import style0 from "./AboutCladify.vue?vue&type=style&index=0&id=68114e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68114e66",
  null
  
)

export default component.exports